import { render, staticRenderFns } from "./suInvoicevoidBList.vue?vue&type=template&id=2bc70b5e"
import script from "./suInvoicevoidBList.vue?vue&type=script&lang=js"
export * from "./suInvoicevoidBList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports